import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"content-header\"><div class=\"container-fluid\"><div class=\"row mb-2\"><div class=\"col-sm-6\"><h1>Tipos de clientes</h1></div><div class=\"col-sm-6\"><ol class=\"breadcrumb float-sm-right\"><li class=\"breadcrumb-item\"><a href=\"#\">Home</a></li><li class=\"breadcrumb-item active\">Tipos de clientes</li></ol></div></div></div></section>", 1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "input-group input-group-sm" }
const _hoisted_8 = { class: "input-group-append" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "card-tools" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-redo",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "card-body table-body" }
const _hoisted_17 = {
  class: "table-button-container",
  style: {"text-align":"center"}
}
const _hoisted_18 = { class: "btn-group" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx, _cache) {
  const _component_table_lite = _resolveComponent("table-lite")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.filter) = $event)),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys((...args) => (_ctx.doFilter && _ctx.doFilter(...args)), ["enter"])),
                  type: "text",
                  class: "form-control",
                  placeholder: "Pesquisar..."
                }, null, 544), [
                  [_vModelText, _ctx.filter]
                ]),
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-info btn-flat",
                    onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.doFilter && _ctx.doFilter(...args)))
                  }, _hoisted_10)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                id: "newButton",
                class: "btn btn-sm btn-default btn-new",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.reload())),
                style: {"width":"33px"},
                "data-tooltip": "Atualizar"
              }, _hoisted_13),
              (_ctx.hasPermission('create'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    id: "newButton",
                    class: "btn btn-sm btn-primary btn-new",
                    onClick: _cache[4] || (_cache[4] = $event => (_ctx.newRow())),
                    style: {"width":"33px"},
                    "data-tooltip": "Novo"
                  }, _hoisted_15))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_table_lite, {
              "is-slot-mode": true,
              "is-loading": _ctx.table.isLoading,
              columns: _ctx.table.columns,
              rows: _ctx.table.rows,
              total: _ctx.table.totalRecordCount,
              sortable: _ctx.table.sortable,
              messages: _ctx.table.messages,
              onDoSearch: _ctx.doSearch,
              onIsFinished: _cache[5] || (_cache[5] = $event => (_ctx.table.isLoading = false))
            }, {
              enabled: _withCtx((props) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge", {
                'bg-success': props.value.enabled,
                'bg-danger': !props.value.enabled
              }])
                }, _toDisplayString(props.value.enabled ? 'Ativo' : 'Inativo'), 3)
              ]),
              actions: _withCtx((props) => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    (_ctx.hasPermission('read'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: $event => (_ctx.view(props.value)),
                          class: "btn btn-sm btn-success",
                          "data-tooltip": "Abrir",
                          "data-delay": "500",
                          "data-hasqtip": "0",
                          "aria-describedby": "qtip-0"
                        }, _hoisted_21, 8, _hoisted_19))
                      : _createCommentVNode("", true),
                    (_ctx.hasPermission('edit'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          onClick: $event => (_ctx.edit(props.value)),
                          class: "btn btn-sm btn-warning",
                          "data-tooltip": "Editar",
                          "data-delay": "500",
                          "data-hasqtip": "0",
                          "aria-describedby": "qtip-0"
                        }, _hoisted_24, 8, _hoisted_22))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["is-loading", "columns", "rows", "total", "sortable", "messages", "onDoSearch"])
          ])
        ])
      ])
    ])
  ], 64))
}